import './App.css';

import Home from './screens/Home';
import PageHeader from './components/organisms/PageHeader';
import About from './screens/About';
import Services from './screens/Services';
import { BrowserRouter, Routes, Route } from "react-router-dom";



function App() {
  return (
    // <div className="App">
    //   <PageHeader/>
    //   <Home />
    // </div>
    <BrowserRouter className="App">
    <PageHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
      </Routes>
    </BrowserRouter>

  );
}

export default App;
